export default __webpack_public_path__ + "static/screeny-130-ga-5-4f67783eb0eea9d2365f8e4986d34906.jpg";